import { createUseStyles } from 'react-jss';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';

const styles = {
  content: { paddingBottom: '5rem', position: 'relative', minHeight: '10rem' },
  tableContent: {
    maxWidth: '80vw',
    [breakpoints.md.down]: {
      maxWidth: '90vw',
    },
  },
  spinnerBg: { borderRadius: '1rem' },
};

const createStyles = createUseStyles(styles);
export { createStyles };
